

export default {
  linkList: function (item) {
   // console.log('点击了',item.ProductCataId);
   // console.log('点击了WebFunctionID',item.WebFunctionID);

    let linkUrl = ''
    let _this = this;
    let isShowSelect = 1
    let listtype = ''
    if (item.TypeId == 'area' && item.WebFunctionID) {
      //   _this.$router.push({
      //     path: '/category',
      //     query: {
      //       ProductCataID: item.ProductCataId,
      //       isType: false,
      //       isFromType: false,
      //       isShowSelect: 0,
      //       WebFunctionID:item.WebFunctionID
      //     }
      //   })
     // console.log('跳转1');
      listtype = 'w'
      linkUrl = `/category?ProductCataID=${item.ProductCataId}&isType=false&isFromType=${item.ProductCataID > 0 ? true : false}&isShowSelect=1&WebFunctionID=${item.WebFunctionID}&listtype=${listtype}`

    } else if (item.TypeId == 'goods' && item.ProductID) {
    //  console.log('跳转2');

      linkUrl = `/productDetail?id=${item.ProductID}`
    } else if (item.TypeId == 'cata' && item.ProductCataId) {
      listtype = 'c'
    //  console.log('跳转3');
    //  console.log(item.WebFunctionID);
      if (item.WebFunctionID == 0) {
        isShowSelect = 0
      }
      if (item.ProductCataJumpType == 10) {
        //葡萄酒
        this.$router.push({
          path: "/redwine",
          query: {
            ProductCataID: cata.ProductCataID,
            isType: true,
            isFromType: true,
            isShowSelect: 1,
            
          },
        });
      } else if (item.ProductCataJumpType == 20 || item.ProductCataJumpType == 30 || item.ProductCataJumpType == 40) {
      //  console.log("特殊页面了");
        // this.$router.push({
        //   path: "/category",
        //   query: {
        //     ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
        //     isFromType: cata.ProductCataID > 0 ? true : false,
        //     isShowSelect: 1,
        //     WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
        //     PropertyIDs: "",
        //     // isShowCN: 1,
        //     isShowCN: 0,
        //     ishidden: true,
        //   },
        // });

        linkUrl = `/category?ProductCataID=${item.ProductCataId}&isType=false&isFromType=true&ishidden=true&isShowSelect=${isShowSelect}&WebFunctionID=0&listtype=${listtype}`
        
      } else if (item.ParentID == 1433) {
        this.$router.push({
          path: "/category",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 0,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
          },
        });

      } else {

        // console.log('厨房判断', item);
        // if (item.ProductCataId == 1433) {
          // linkUrl = `/category?ProductCataID=${item.ProductCataId}&isType=false&isFromType=true&ishidden=true&isShowSelect=${isShowSelect}&WebFunctionID=`

        // } else {
          linkUrl = `/category?ProductCataID=${item.ProductCataId}&isType=false&isFromType=true&isShowSelect=${isShowSelect}&WebFunctionID=${item.WebFunctionID}`

        // }

        // linkUrl = `/category?ProductCataID=${item.ProductCataId}&isType=false&isFromType=true&isShowSelect=${isShowSelect}&WebFunctionID=`

      }

      //   _this.$router.push({
      //     path: '/category',
      //     query: {
      //       ProductCataID: item.ProductCataId,
      //       isType: false,
      //       isFromType: true,
      //       isShowSelect: 0,
      //       WebFunctionID:""
      //     }
      //   })
    } else if (item.TypeId == "partycatering"){
      linkUrl = `/OrderFood?WebFunctionID=${item.WebFunctionID}&ProductCataID=0`
    }else if (item.TypeId == 'aboutinner' && item.NotifyID) {
      linkUrl = `/about?NotifyId=${item.NotifyID}`
    } else if (item.TypeId == 'classifypage' && item.ClassifyId) {
    //  console.log('跳转4');
      linkUrl = `/category?ProductCataID=${item.ClassifyId}&isFromType=false`
    } else if (item.TypeId == 'anxinpei') {
      linkUrl = '/monthlyNutrition'
    } else if (item.TypeId == 'sales') {
      linkUrl = `/sale?WebFunctionID=${item.WebFunctionID}`
    } else if (item.TypeId == 'eperbox') {
      //eperbox
      linkUrl = '/eperBox'
    } else if (item.TypeId == 'boutique') {
      //菩提客
      linkUrl = '/supplier'
    } else if (item.TypeId == 'eperfarm') {
    //  console.log('关于农场')
    } else if (item.TypeId == 'RedemptionShow') {
      linkUrl = `/integralMall`
    } else if (item.TypeId == 'rechargeOnline') {
      linkUrl = '/user/onlineRecharge'
    } else if (item.TypeId == 'rainbow') {
      linkUrl = '/rainbow'
    } else if (item.TypeId == 'boutique') {
      linkUrl = '/epermarketSub/boutique'
    } else if (item.TypeId == 'refer') {
      linkUrl = '/user/invitation'
    } else if (item.TypeId == 'advertisingpage') {
      linkUrl = '/newLetter?goAdvertisin=' + item.GoAdvertisin
    } else if (item.TypeId == 'rainbowdetails') {
      linkUrl = '/rainbow/productDetail?id=' + item.RainbowId
    } else if (item.TypeId == 'eupagetype') {
      linkUrl = '/eu'
    } else if (item.TypeId == "hyperlinks") {
      linkUrl = item.LinkUrl
    } else if (item.TypeId == "promwebfunction" && item.PromWebFunctionID) {
      linkUrl = `/PromCategoryList?PromWebFunctionID=${item.PromWebFunctionID}`
    } else if (item.TypeId == "specialfood"){
      linkUrl = `/freeFrom`
    } else if(item.TypeId == "subjectfunction"){
      linkUrl = `/newWine?SubjectFunctionID=${item.SubjectFunctionID}&isShowSelect=1&listtype=w&isFromType=false`
    }
    if (linkUrl != '') {
      window.open(linkUrl, '_blank');
    }

  },
  NewlinkList:function(item){
   console.log(item);
    let linkUrl = ''
    let _this = this;
    let isShowSelect = 1
    let listtype = ''
    if (item.TypeName == 'area' && item.TypeValue) {
      listtype = 'w'
      linkUrl = `/category?ProductCataID=0&isType=false&isFromType=false&isShowSelect=1&WebFunctionID=${item.TypeValue}&listtype=${listtype}`

    } else if (item.TypeName == 'goods' && item.TypeValue) {
      linkUrl = `/productDetail?id=${item.TypeValue}`
    } else if (item.TypeName == 'cata' && item.TypeValue) {
      listtype = 'c'
      if (item.TypeValue == 0) {
        isShowSelect = 0
      }
      if (item.JumpType == 10) {
        //葡萄酒
        this.$router.push({
          path: "/redwine",
          query: {
            ProductCataID: cata.ProductCataID,
            isType: true,
            isFromType: true,
            isShowSelect: 1,
            
          },
        });
      } else if (item.JumpType == 20 || item.JumpType == 30 || item.JumpType == 40) {
        linkUrl = `/category?ProductCataID=${item.TypeValue}&isType=false&isFromType=true&ishidden=true&isShowSelect=${isShowSelect}&WebFunctionID=0&listtype=${listtype}`
      } else if (item.TypeValue == 1433) {
        this.$router.push({
          path: "/category",
          query: {
            ProductCataID: cata.ProductCataID > 0 ? cata.ProductCataID : 0,
            isFromType: cata.ProductCataID > 0 ? true : false,
            isShowSelect: 0,
            WebFunctionID: cata.WebFunctionID > 0 ? cata.WebFunctionID : "",
            PropertyIDs: "",
          },
        });
      } else {
        linkUrl = `/category?ProductCataID=${item.TypeValue}&isType=false&isFromType=true&isShowSelect=${isShowSelect}&WebFunctionID=${item.TypeValue}`
      }
    } else if (item.TypeName == 'aboutinner' && item.TypeValue) {
      linkUrl = `/about?NotifyId=${item.TypeValue}`
    } else if (item.TypeName == 'classifypage' && item.TypeValue) {
    //  console.log('跳转4');
      linkUrl = `/category?ProductCataID=${item.TypeValue}&isFromType=false`
    } else if (item.TypeName == 'anxinpei') {
      linkUrl = '/monthlyNutrition'
    } else if (item.TypeName == 'sales') {
      linkUrl = `/sale?WebFunctionID=${item.TypeValue}`
    } else if (item.TypeName == 'eperbox') {
      //eperbox
      linkUrl = '/eperBox'
    } else if (item.TypeName == 'boutique') {
      //菩提客
      linkUrl = '/supplier'
    } else if (item.TypeName == 'eperfarm') {
     // console.log('关于农场')
    } else if (item.TypeName == 'RedemptionShow') {
      linkUrl = `/integralMall`
    } else if (item.TypeName == 'rechargeOnline') {
      linkUrl = '/user/onlineRecharge'
    } else if (item.TypeName == 'rainbow') {
      linkUrl = '/rainbow'
    } else if (item.TypeName == 'boutique') {
      linkUrl = '/epermarketSub/boutique'
    } else if (item.TypeName == 'refer') {
      linkUrl = '/user/invitation'
    } else if (item.TypeName == 'advertisingpage') {
      linkUrl = '/newLetter?goAdvertisin=' + item.TypeValue
    } else if (item.TypeName == 'rainbowdetails') {
      linkUrl = '/rainbow/productDetail?id=' + item.TypeValue
    } else if (item.TypeName == 'eupagetype') {
      linkUrl = '/eu'
    } else if (item.TypeName == "hyperlinks") {
      linkUrl = item.LinkUrl
    } else if (item.TypeName == "promwebfunction" && item.TypeValue) {
      linkUrl = `/PromCategoryList?PromWebFunctionID=${item.TypeValue}`
    } else if (item.TypeName == "specialfood"){
      linkUrl = `/freeFrom`
    } else if(item.TypeName == "subjectfunction"){
      linkUrl = `/newWine?SubjectFunctionID=${item.TypeValue}&isShowSelect=1&listtype=w&isFromType=false`
    }
    if (linkUrl != '') {
      window.open(linkUrl, '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/until/until.js